// extracted by mini-css-extract-plugin
export default {"loaderContainer":"CommonLoader_loaderContainer__-H8eZ"};